import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { adminGroups, adminCreateGroup, adminUpdateGroup, adminDeleteGroup, formatApiErrorDetail } from "@/lib/api";
import { Trash2, Pencil, X, Plus } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { name: "", company: "", training_program: "", topic: "", description: "" };

export default function AdminGroups() {
  const [groups, setGroups] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => adminGroups().then(setGroups).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (edit.id) await adminUpdateGroup(edit.id, edit);
      else await adminCreateGroup(edit);
      toast.success("Saved"); setEdit(null); load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed"); }
  };
  const del = async (g) => {
    if (!window.confirm(`Delete group "${g.name}"?`)) return;
    await adminDeleteGroup(g.id); toast.success("Deleted"); load();
  };

  return (
    <AdminLayout>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1 className="rbl-h1" style={{ fontSize: 34 }}>Groups</h1>
        <button className="rbl-btn" onClick={() => setEdit({ ...EMPTY })} data-testid="add-group-btn"><Plus size={16} /> Add group</button>
      </div>
      <div style={{ marginTop: 18 }} data-testid="groups-list">
        {groups.map((g) => (
          <div key={g.id} className="rbl-list-item" data-testid={`group-${g.id}`}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700 }}>{g.name} {g.part2 && <span className="rbl-badge" data-testid={`group-part2-badge-${g.id}`}>PART 2</span>}</div>
              <div style={{ color: "var(--muted)", fontSize: 13 }}>{g.company} · {g.participant_count} participants</div>
            </div>
            <button className="rbl-icon-btn" onClick={() => setEdit(g)} data-testid={`edit-group-${g.id}`}><Pencil size={18} /></button>
            <button className="rbl-icon-btn danger" onClick={() => del(g)} data-testid={`del-group-${g.id}`}><Trash2 size={18} /></button>
          </div>
        ))}
      </div>
      {edit && (
        <div className="rbl-modal-bg" onClick={() => setEdit(null)}>
          <div className="rbl-modal" onClick={(e) => e.stopPropagation()} data-testid="group-modal">
            <div style={{ display: "flex", justifyContent: "space-between" }}><h3 style={{ margin: 0 }}>{edit.id ? "Edit" : "Add"} group</h3>
              <button className="rbl-link" onClick={() => setEdit(null)} style={{ border: "none", background: "none" }}><X size={18} /></button></div>
            <form onSubmit={save}>
              {[["name", "Name"], ["company", "Company"], ["training_program", "Training program"], ["topic", "Topic"]].map(([k, label]) => (
                <div className="rbl-field" key={k}><label className="rbl-label">{label}</label>
                  <input className="rbl-input" data-testid={`group-${k}`} required={k === "name"} value={edit[k] || ""} onChange={(e) => setEdit({ ...edit, [k]: e.target.value })} /></div>
              ))}
              <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 14, margin: "6px 0 10px" }}>
                <input type="checkbox" data-testid="group-part2" checked={!!edit.part2} onChange={(e) => setEdit({ ...edit, part2: e.target.checked })} /> Part 2 access (4 training days)
              </label>
              {edit.part2 && (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                  {[0, 1, 2, 3].map((i) => (
                    <div className="rbl-field" key={i} style={{ margin: 0 }}><label className="rbl-label">Day {i + 1} date</label>
                      <input type="date" className="rbl-input" data-testid={`group-part2-date-${i + 1}`} value={(edit.part2_dates || [])[i] || ""}
                        onChange={(e) => { const ds = [...(edit.part2_dates || ["", "", "", ""])]; ds[i] = e.target.value; setEdit({ ...edit, part2_dates: ds }); }} /></div>
                  ))}
                </div>
              )}
              <button className="rbl-btn block" data-testid="group-save" style={{ marginTop: 12 }}>Save</button>
            </form>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
